import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { Seo } from '@components/Seo';
import PrivacyPolicy from '@docs/polityka_prywatnosci.raw.html';

const PRIVACY_TITLE = 'Polityka prywatności';
const PRIVACY_DESCRIPTION =
  'Polityka prywatności i Polityka Cookies serwisu Praca na Kołach. Informacje o przetwarzaniu danych osobowych i plikach cookies.';

export const PrivacyPolicyView: React.FC<RouteComponentProps> = ({ location }) => {
  const canonicalUrl =
    typeof window !== 'undefined' && location
      ? `${window.location.origin}${location.pathname}`
      : undefined;
  const docWithSingleH1 = PrivacyPolicy.replace(/<h1/gi, '<h2').replace(/<\/h1>/gi, '</h2>');
  return (
    <>
      <Seo title={PRIVACY_TITLE} description={PRIVACY_DESCRIPTION} url={canonicalUrl} />
      <div className="grid-container">
        <div className="grid-x align-center">
          <div className="cell">
            <h1 style={{ marginBottom: 24 }}>{PRIVACY_TITLE}</h1>
            <div className="doc" dangerouslySetInnerHTML={{ __html: docWithSingleH1 }} />
          </div>
        </div>
      </div>
    </>
  );
};
